import React, { Component } from 'react';
import './styles.css';

export default class Form extends Component {
  render() {
    return (
      <form onSubmit={this.props.onSubmit}>
        {this.props.children}
      </form>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/Form/Form.js